import React, {h, Component} from 'preact';
import _ from 'lodash';

const ADDRESS_ERROR_STATES = {
    emptyAddress: 'Please enter your address to get free quotes.',
    invalidAddress: 'Please enter a valid address with a number, street name, city, and state.'
};

const PROVIDER_NAMES_BY_KEY = {
    facebook: 'Facebook',
    google: 'Google',
    linkedin: 'LinkedIn'
};

const KEY_CODE = {
    SPACE: 32,
    COMMA: 188
};

export default class SellContactFormStep extends Component {
    constructor(props) {
        super(props);

        this.refs = {};
        this.loggedInUser = props.loggedInUser;
        this.isNewUser = true;
        this.isAdmin = false;
        this.isRealtor = props.loggedInUser ? !!props.loggedInUser.realtorId : false;
        this.state = {
            loginProvider: null,
            isLoggedIn: !!props.loggedInUser,
            userExists: false,
            isPhoneVisible: false,
            errors: {}
        };
        this.checkUserExistsDebounced = _.debounce(() => this.checkUserExists(), 500, {trailing: true});
        this.notifyOnValidationErrorThrottled = throttle(() => this.notifyOnValidationError(), 500, {
            trailing: true,
            leading: false
        });
        $(this.refs.form)
            .find('#address, #email, #name')
            .trimmable();

        const parentState = props.parent.state;
        if (parentState.zestimate) {
            this.estimate = parentState.zestimate;
        } else if (!parentState.lowRange) {
            this.estimate = parentState.highRange;
        } else {
            this.estimate = (+parentState.lowRange + +parentState.highRange) / 2 || 0;
        }
    }

    componentDidMount() {
        if (this.props.realtorId) {
            let data = {
                'dlink': this.props.dlink,
                'tag': this.props.tag,
                'prop.address': this.props.address,
                'prop.homeType': this.props.homeType,
                'email': this.props.email,
                'name': this.props.name,
                'phone': this.props.phone
            };
            if (this.props.alsoBuying) {
                data.alsoBuying = this.props.alsoBuying;
            }
            this.props.parent.submitPromise = $.post('api/submitRequestDirect-json', data).then(data => {
                data = {...data, ...data.req};

                if (data.redirectUrl) {
                    window.location = data.redirectUrl;
                    return;
                }
                if (data.rejectReason === 'duplicateRequest') {
                    this.handleDuplicateRequest({
                        address: this.props.address,
                        name: this.props.name,
                        email: this.props.email,
                        requestId: data.requestId
                    });
                    return $.Deferred()
                        .reject(new Error(data.msg))
                        .promise();
                }
                if (data.msg) {
                    window.location = 'index?msg=' + encodeURIComponent(data.msg);
                    return;
                }
                trackSellRequestConversion(data, !!this.props.phone ? null : +phonelessConversionPct);
                trackEvent('Flow', data.requestId, 'sellV3Step3Chat', {hasPhone: !!this.props.phone})
                    .withOptimizely()
                    .withGA();
                this.props.parent.setState({
                    requestId: data.requestId,
                    currentStep: 'SELL_CHAT'
                });
                return data;
            });
            this.props.parent.submitPromise.then(data => {
                $.post('sellerInviteAgent-json?', {requestId: data.requestId, realtorId: this.props.realtorId});
            });
            trackEvent('Flow', 'SellRequest', 'sellV3Step2c')
                .withOptimizely()
                .withGA();
            this.props.parent.setState({currentStep: 'LOADING'});
            return;
        }

        trackEvent('Flow', 'SellRequest', 'sellV3Step2c')
            .withOptimizely()
            .withGA();

        $('#flow-container .float-label-div').initFloatLabels();

        this.assignAddressUpdateHandler();

        this.validator = $(this.refs.form).validate({
            rules: {
                name: {
                    minlength: 5,
                    minWords: 2,
                    pattern: "[A-Za-z\u0300-\u0315-.,'’ ]+"
                }
            },
            messages: {
                name: {
                    minlength: jQuery.format('Please enter at least {0} characters'),
                    minWords: jQuery.format('Please enter your first and last name.'),
                    pattern: jQuery.format(
                        "Only A-Z, a-z, comma, apostrophe, period and hyphen ( , ' ’ . - ) are allowed."
                    )
                },
                unit: {
                    required: 'Unit # is required.'
                },
                phone: {
                    phoneUS: 'Please specify a valid 10-digit phone number.'
                }
            },
            invalidHandler: (form, validator) => {
                validator.focusInvalid();
                this.highlightValidationErrors(validator.errorList);
                this.trackValidationError();
                this.notifyOnValidationErrorThrottled();
            }
        });

        if (this.props.address) {
            this.validateAddress();
        }

        if (this.props.loggedInUser) {
            $(this.refs.name)
                .val(this.props.loggedInUser.name)
                .trigger('input');
            $(this.refs.email)
                .val(this.props.loggedInUser.email)
                .trigger('input');
            $(this.refs.phone)
                .val(this.phoneFormat(this.props.loggedInUser.phone))
                .trigger('input');
            this.setState({isPhoneVisible: true});
        }

        if ($(this.refs.phone).val()) {
            this.setState({isPhoneVisible: true});
        }
    }

    shouldComponentUpdate() {
        return !$('#suggestedEmail').length;
    }

    assignAddressUpdateHandler() {
        if (this.refs.address) {
            this.props.parent.addressDetails = null;

            this.props.parent.locationBiasPromise.then(locationBias => {
                const autocomplete = new google.maps.places.Autocomplete(this.refs.address, {
                    bounds: locationBias,
                    types: ['address'],
                    componentRestrictions: {country: 'us'}
                });
                autocomplete.setFields(['address_components', 'geometry']);
                autocomplete.addListener('place_changed', () => {
                    let place = autocomplete.getPlace();
                    let addressComponents = (place && place['address_components']) || [];
                    let addressDetails = (this.props.parent.addressDetails = {});
                    let localities = null;
                    for (const component of addressComponents) {
                        if (localities && $.inArray('administrative_area_level_1', component.types) === -1) {
                            localities.unshift(component['long_name']);
                        }
                        if ($.inArray('street_number', component.types) !== -1) {
                            addressDetails.streetNumber = component['short_name'];
                        } else if ($.inArray('route', component.types) !== -1) {
                            addressDetails.street = component['short_name'];
                            localities = [];
                        } else if ($.inArray('locality', component.types) !== -1) {
                            addressDetails.city = component['long_name'];
                        } else if (
                            !addressDetails.city &&
                            $.inArray('administrative_area_level_3', component.types) !== -1
                        ) {
                            addressDetails.city = component['long_name'];
                        } else if (
                            !addressDetails.city &&
                            $.inArray('administrative_area_level_2', component.types) !== -1
                        ) {
                            addressDetails.city = component['long_name'];
                        } else if ($.inArray('administrative_area_level_1', component.types) !== -1) {
                            addressDetails.state = component['short_name'];
                            if (localities && localities.length > 0) {
                                addressDetails.addressComponents = localities.join(',');
                            }
                            localities = null;
                        } else if ($.inArray('postal_code', component.types) !== -1) {
                            addressDetails.zip = component['short_name'];
                        } else if ($.inArray('country', component.types) !== -1) {
                            addressDetails.country = component['short_name'];
                        }
                    }
                    if (!addressDetails.streetNumber || !addressDetails.street || !addressDetails.city) {
                        addressDetails = null;
                    } else {
                        addressDetails.streetAddress = addressDetails.streetNumber + ' ' + addressDetails.street;
                        if (place.geometry && place.geometry.location) {
                            addressDetails.mapLongitude = place.geometry.location.lng();
                            addressDetails.mapLatitude = place.geometry.location.lat();
                        }
                    }
                    this.props.parent.addressDetails = addressDetails;
                    this.hasAddressBeenValidated = false;
                    this.validateAddress();
                });
                $(this.refs.address).on('change', () => {
                    this.hasAddressBeenValidated = false;
                    this.props.parent.addressDetails = null;
                    this.validateAddress();
                });
                $(this.refs.unit).on('change', () => {
                    this.hasAddressBeenValidated = false;
                    this.validatedAddress = '';
                    this.props.parent.addressDetails = null;
                    this.validateAddress();
                });
            });
        }
    }

    reFormatPhone() {
        if (!this.refs.phone) {
            return;
        }
        const phone = this.refs.phone.value;
        if (phone) {
            this.refs.phone.value = this.phoneFormat(phone, this.props.country);
        }
    }

    onEmailKeyDown(event) {
        const keyCode = event.keyCode || event.which;
        if (KEY_CODE.SPACE === keyCode || KEY_CODE.COMMA === keyCode) {
            event.preventDefault();
        }
    }

    onEmailInput(event) {
        this.onInput(event);
        $('#welcomeBack').hide();
        this.checkUserExistsDebounced();
    }

    onInput = throttle(
        () => {
            const state = this.props.parent.state;
            const data = {
                isBuyer: false,
                lowRange: state.lowRange,
                highRange: state.highRange,
                priceRangeRank: state.priceRangeRank,
                location: this.props.location,
                homeType: state.homeType,
                address: state.address,
                name: $(this.refs.name).val() || state.name,
                email: $(this.refs.email).val(),
                phone: $(this.refs.phone).val(),
                agentPreference: state.agentPreference
            };
            $.post('save-incomplete-request', data);
        },
        3000,
        {
            trailing: true,
            leading: true
        }
    );

    onPhoneChange(event, country) {
        this.onInput(event);
        let obj = event.target;
        let keyCode = 'which' in event ? event.which : event.keyCode;
        if (keyCode !== 8 && !event.ctrlKey) {
            obj.value = this.phoneFormat(obj.value, country);
        }
    }

    phoneFormat(val) {
        let numbersOnly = val.replace(/[^0-9]/g, '');
        if (!this.props.isNotUS) {
            if (!numbersOnly) {
                return '';
            }
            return (
                '(' +
                numbersOnly.substr(0, 3) +
                (numbersOnly.length > 2 ? ')' : '') +
                (numbersOnly.length > 3 ? ' ' + numbersOnly.substr(3, 3) : '') +
                (numbersOnly.length > 6 ? '-' + numbersOnly.substr(6, 7) : '')
            );
        }
        return numbersOnly;
    }

    checkUserExists() {
        const $email = $(this.refs.email);
        if (!$email.val() || !$email.valid()) {
            this.isNewUser = false;
            this.isRealtor = false;
            this.isAdmin = false;
            this.setState({
                loginProvider: null,
                isLoggedIn: false,
                userExists: false
            });
            return $.Deferred().resolve({});
        }

        return $.get('userExist-json?email=' + encodeURIComponent($email.val())).then(data => {
            const $phone = $(this.refs.phone);
            const userExists =
                data.email &&
                (!this.loggedInUser || this.loggedInUser.email.toLowerCase() !== data.email.toLowerCase());
            const showPhone =
                !data.realtorId &&
                !data.admin &&
                (!(data.phone && userExists) || (data.provider && PROVIDER_NAMES_BY_KEY[data.provider]));
            if (!data.realtorId && !userExists) {
                $phone.removeClass('error');
            }
            this.isNewUser = !data.email;
            this.isRealtor = !!data.realtorId;
            this.isAdmin = !!data.admin;
            this.handleValidation($email[0]);
            this.setState({
                loginProvider: data.provider || null,
                userExists,
                isPhoneVisible: showPhone
            });
            if (!showPhone) {
                $phone.val('').removeClass('error');
            }
            if (userExists) {
                trackEvent('Flow', 'sellWelcomeBack').withGA();
            }
            return data;
        });
    }

    highlightValidationErrors(errors) {
        for (const {message, element} of errors) {
            $(element)
                .closest('.float-label-div')
                .addClass('error');
            this.setState(currentState => ({
                errors: {...currentState.errors, [element.name]: message}
            }));
        }
    }

    trackValidationError(errorCategory) {
        trackEvent(
            'Flow',
            'SellRequest',
            'requestFlowValidationError' + (errorCategory ? '_' + errorCategory : '')
        ).withGA();
    }

    notifyOnValidationError() {
        const error = $(this.refs.form)
            .find('label.error:visible:not(.from-server)')
            .map(function() {
                return '[' + $(this).attr('for') + ']: ' + $(this).text();
            })
            .get()
            .join(' ');
        if (!error) {
            return;
        }

        let form = $(this.refs.form).serialize() + '&error=' + encodeURIComponent(error);
        if (form !== this.erroneousForm) {
            const parent = this.props.parent;
            this.erroneousForm = form;
            form += '&tag=' + encodeURIComponent(parent.props.tag);
            form += '&lowRange=' + encodeURIComponent(parent.state.lowRange);
            form += '&highRange=' + encodeURIComponent(parent.state.highRange);
            form += '&location=' + encodeURIComponent(parent.props.location);
            form += '&homeType=' + encodeURIComponent(parent.state.homeType);
            form += '&agentPreference=' + encodeURIComponent(parent.state.agentPreference);
            if (!this.refs.name && parent.state.name) {
                form += '&name=' + encodeURIComponent(parent.state.name);
            }
            if (!this.refs.address && parent.state.address) {
                form += '&address=' + encodeURIComponent(parent.state.address);
            }
            if (window.screen) {
                if (window.screen.width) {
                    form += '&screenWidth=' + window.screen.width;
                }
                if (window.screen.height) {
                    form += '&screenHeight=' + window.screen.height;
                }
            }
            form += '&isSeller=true';
            $.post('notifyOnValidationError', form);
        }
    }

    validateAddress = _.debounce(
        () => {
            if (this.refs.address) {
                this.props.address = this.refs.address.value;
                this.handleValidation(this.refs.address);
            }
            const address = this.refs.address && $(this.refs.address).val();
            if (this.validatedAddress === address) {
                this.validationPromise = $.Deferred().resolve();
                return;
            }

            this.validatedAddress = address;

            if (this.refs.address && !$(this.refs.address).valid()) {
                this.validationPromise = $.Deferred().resolve();
                return;
            }
            if (this.hasAddressBeenValidated) {
                this.validationPromise = $.Deferred().resolve();
                return;
            }

            $(this.refs.addressBlock)
                .find('label.error')
                .remove();
            $(this.refs.addressBlock).removeClass('error');

            let unit = $(this.refs.unit).val();
            let homeType = this.props.parent.state.homeType;
            let name = $(this.refs.name).val();
            let email = $(this.refs.email).val();
            let phone = $(this.refs.phone).val();
            let parent = this.props.parent;
            let params = {
                'location': this.props.location,
                'prop.address': parent.state.address || address,
                'prop.unit': unit,
                'prop.homeType': homeType,
                'req.agentPreference': parent.state.agentPreference,
                'name': parent.state.name || name,
                'email': email,
                'phone': phone
            };

            if (parent.state.lowRange || parent.state.highRange) {
                params.lowRange = parent.state.lowRange || 0;
                params.highRange = parent.state.highRange || parent.state.lowRange * 2;
            }

            if (parent.addressDetails) {
                let addressDetails = parent.addressDetails;
                params['prop.address'] = addressDetails.streetAddress;
                params['prop.unit'] = parent.addressDetails.unit || '';
                params['prop.city'] = addressDetails.city;
                params['prop.addressComponents'] = addressDetails.addressComponents;
                params['prop.state'] = addressDetails.state;
                params['prop.zip'] = addressDetails.zip;
                params['prop.country'] = addressDetails.country;
                params['prop.mapLongitude'] = addressDetails.mapLongitude;
                params['prop.mapLatitude'] = addressDetails.mapLatitude;
                params['prop.MSA'] = addressDetails.prop ? addressDetails.MSA : null;
                params['prop.county'] = addressDetails.prop ? addressDetails.county : null;
                params['prop.baths'] = addressDetails.prop ? addressDetails.baths : null;
                params['prop.beds'] = addressDetails.prop ? addressDetails.beds : null;
                params['prop.finishedSqFt'] = addressDetails.prop ? addressDetails.finishedSqFt : null;
                params['prop.homeType'] = addressDetails.prop ? addressDetails.homeType : homeType || null;
                params.skipAddressNormalization = true;
                params.skipFetchingEstimate = !!addressDetails.estimate;
            }

            this.hasAddressBeenValidated = true;

            $(this.refs.address).after('<div class="check-mark"><i class="icon-nav-check"/></div>');
            this.validationPromise = $.post('api/validateDirectSubmit-json', params).then(data => {
                if (data.redirectUrl) {
                    window.location = data.redirectUrl;
                    return;
                }
                if (data.skipAddressNormalization) {
                    let addressDetails = this.props.parent.addressDetails || {};
                    addressDetails.streetAddress = data.prop.address;
                    addressDetails.city = data.prop.city;
                    addressDetails.addressComponents = data.prop.addressComponents;
                    addressDetails.state = data.prop.state;
                    addressDetails.zip = data.prop.zip;
                    addressDetails.country = data.prop.country;
                    addressDetails.mapLongitude = data.prop.mapLongitude;
                    addressDetails.mapLatitude = data.prop.mapLatitude;
                    addressDetails.unit = data.prop.unit;
                    this.props.parent.addressDetails = addressDetails;
                }
                if (data.skipFetchingEstimate) {
                    this.props.parent.addressDetails = this.props.parent.addressDetails || {};
                    this.props.parent.addressDetails.estimate = (data.req || {}).zestimate;
                    this.props.parent.addressDetails.prop = data.prop;
                }
                if (data.msg) {
                    if ($(this.refs.addressBlock).find('label.error').length === 0) {
                        $(this.refs.addressBlock)
                            .find('.check-mark')
                            .remove();
                        $(this.refs.addressBlock).addClass('error');
                        $(this.refs.address).after(
                            $('<label for="address" generated="true" class="error from-server"/>').html(
                                ADDRESS_ERROR_STATES[data.rejectReason] || data.msg
                            )
                        );
                    }
                    this.hasAddressBeenValidated = false;
                } else {
                    this.hasAddressBeenValidated = true;
                }
                return data;
            });
        },
        150,
        {trailing: true, leading: true}
    );

    doSocialLogin(provider) {
        if (this.state.userExists) {
            trackEvent('sellRequestFlow_ClickProviderExisting_' + PROVIDER_NAMES_BY_KEY[provider]).withGA();
        } else {
            trackEvent('sellRequestFlow_ClickProvider_' + PROVIDER_NAMES_BY_KEY[provider]).withGA();
        }

        trackEvent(
            'Flow',
            `oneallSellerClickedOn${PROVIDER_NAMES_BY_KEY[provider]}Button`,
            `oneallSellerClickedOn${PROVIDER_NAMES_BY_KEY[provider]}Button`
        );

        this.setState({
            selectedLoginProvider: provider,
            isPerformingSocialLogin: true
        });

        logInWithProvider(provider, result => {
            const {cancelled, connectionToken} = result;

            if (cancelled) {
                this.setState({isPerformingSocialLogin: false});
                return;
            }

            $.post('oneAllLoginAndSignup-json', {connection_token: connectionToken})
                .then(data => {
                    if (data.msg) {
                        defaultAjaxError(data.msg);
                        return;
                    }

                    const user = data.user;
                    const {name, phone, email} = this.refs;
                    if (this.refs.name && user.name) {
                        $(name)
                            .val(user.name)
                            .change();
                        this.handleValidation(this.refs.name);
                    }
                    if (user.email) {
                        $(email)
                            .val(user.email)
                            .change();
                        this.handleValidation(this.refs.email);
                    }
                    if (user.phone && !$(phone).val()) {
                        $(phone)
                            .val(user.phone)
                            .change();
                        this.handleValidation(this.refs.phone);
                    }

                    this.loggedInUser = user;
                    this.isNewUser = data.newUser;
                    this.reFormatPhone();
                    this.setState({
                        loginProvider: provider,
                        isLoggedIn: true,
                        isPhoneVisible: true
                    });

                    const providerName = PROVIDER_NAMES_BY_KEY[provider];
                    trackEvent(
                        'Flow',
                        this.isNewUser
                            ? `sellRequestFlow_Signup_${providerName}`
                            : `sellRequestFlow_Login_${providerName}`
                    ).withGA();

                    if (this.state.userExists && $(phone).val() && $(email).val() && $(name).val()) {
                        // User typed in their existing account's email address. In this case we display the
                        // "Continue with X" button that automatically redirects them to the next step after
                        // successful login.
                        this.submit();
                    }
                })
                .always(() => {
                    this.setState({isPerformingSocialLogin: false});
                });
        });
    }

    submit() {
        if (this.state.loginProvider) {
            const loginProviderName = PROVIDER_NAMES_BY_KEY[this.state.loginProvider];
            trackEvent(
                'Flow',
                this.isNewUser
                    ? `sellRequestFlow_SignUp_${loginProviderName}_Submit`
                    : `sellRequestFlow_Login_${loginProviderName}`
            ).withGA();
        }

        if (this.isSubmitting || this.isRealtor || this.isAdmin) {
            return;
        }
        if (!$(this.refs.form).valid()) {
            this.trackValidationError();
            this.notifyOnValidationErrorThrottled();
            return;
        }
        if (!this.state.userExists && !this.state.isPhoneVisible && !$(this.refs.phone).val()) {
            this.setState({isPhoneVisible: true});
            this.reFormatPhone();
            return;
        }

        this.checkUserExists().then(() => {
            if (this.isRealtor || this.isAdmin) {
                return;
            }
            if (!this.state.userExists && !this.state.isPhoneVisible && !$(this.refs.phone).val()) {
                this.setState({isPhoneVisible: true});
                this.reFormatPhone();
                return;
            }

            this.isSubmitting = true;
            this.validateAddress();

            return this.validationPromise.then(validationResult => {
                if (validationResult && validationResult.msg) {
                    $(this.refs.addressBlock)
                        .find('label.error')
                        .remove();
                    if ($(this.refs.addressBlock).find('label.error').length === 0) {
                        $(this.refs.address).after(
                            $('<label for="address" generated="true" class="error from-server"/>').html(
                                validationResult.msg
                            )
                        );
                    }
                    this.trackValidationError(validationResult.rejectReason || 'address');
                    this.notifyOnValidationErrorThrottled();
                    this.isSubmitting = false;
                    return;
                }
                if (!$(this.refs.form).valid()) {
                    this.trackValidationError();
                    this.notifyOnValidationErrorThrottled();
                    this.isSubmitting = false;
                    return;
                }

                let parent = this.props.parent;

                let address = parent.state.address || $(this.refs.address).val();
                let unit = $(this.refs.unit).val();
                let name = parent.state.name || $(this.refs.name).val();
                let email = $(this.refs.email).val();
                let phone = $(this.refs.phone).val();
                let talkNow = true; // $(this.refs.talkNow).prop('checked');

                parent.setState({address, name, email, phone, talkNow});

                let data = {
                    'dlink': parent.props.dlink,
                    'tag': parent.props.tag,
                    'location': parent.props.location,
                    'priceRangeRank': parent.state.priceRangeRank,
                    'expectedListDate': parent.state.expectedListDate,
                    'req.agentPreference': parent.state.agentPreference,
                    'prop.homeType': parent.state.homeType,
                    'req.alsoBuying': parent.state.alsoBuying,
                    'prop.address': address,
                    'prop.unit': unit,
                    'email': email,
                    'name': name,
                    'phone': phone,
                    'req.talkNow': talkNow
                };
                if (parent.state.lowRange || parent.state.highRange) {
                    data.lowRange = parent.state.lowRange || 0;
                    data.highRange = parent.state.highRange || parent.state.lowRange * 2;
                }
                if (parent.addressDetails) {
                    let addressDetails = parent.addressDetails;
                    data['prop.address'] = addressDetails.streetAddress || address;
                    data['prop.unit'] = '';
                    data['prop.city'] = addressDetails.city;
                    data['prop.addressComponents'] = addressDetails.addressComponents;
                    data['prop.state'] = addressDetails.state;
                    data['prop.zip'] = addressDetails.zip;
                    data['prop.country'] = addressDetails.country;
                    data['prop.mapLatitude'] = addressDetails.mapLatitude;
                    data['prop.mapLongitude'] = addressDetails.mapLongitude;
                    data['prop.MSA'] = addressDetails.prop ? addressDetails.prop.MSA : null;
                    data['prop.county'] = addressDetails.prop ? addressDetails.prop.county : null;
                    data['prop.baths'] = addressDetails.prop ? addressDetails.prop.baths : null;
                    data['prop.beds'] = addressDetails.prop ? addressDetails.prop.beds : null;
                    data['prop.finishedSqFt'] = addressDetails.prop ? addressDetails.prop.finishedSqFt : null;
                    data['prop.homeType'] = addressDetails.prop ? addressDetails.prop.homeType : parent.state.homeType;
                    data.skipAddressNormalization = true;
                    data.skipFetchingEstimate = !!addressDetails.estimate;
                    data['req.zestimate'] = addressDetails.estimate;
                }
                if (this.props.alsoBuying) {
                    data.alsoBuying = this.props.alsoBuying;
                }
                trackEvent(
                    'Flow',
                    'SellRequest',
                    !!phone ? 'clientInputPhoneNumberAndEmailAddress' : 'clientInputEmailAddress',
                    {client_Type: 'Seller'}
                )
                    .withOptimizely()
                    .withGA();

                trackEvent('Flow', 'SellRequest', 'sellerRequestStep6ClickedContinue', {
                    abTestWHYVersion: window.abTestWHYVersion
                })
                    .withGA()
                    .withOptimizely();

                this.props.parent.setState({currentStep: 'LOADING'});
                this.props.parent.submitPromise = $.post('api/submitRequestDirect-json', data).then(data => {
                    data = {...data, ...data.req};

                    if (data.redirectUrl) {
                        window.location = data.redirectUrl;
                        return;
                    }
                    if (data.rejectReason === 'duplicateRequest') {
                        this.handleDuplicateRequest({
                            address,
                            name,
                            email,
                            requestId: data.requestId
                        });
                        return $.Deferred()
                            .reject(new Error(data.msg))
                            .promise();
                    }
                    if (data.msg) {
                        window.location = 'index?msg=' + encodeURI(data.msg);
                        return;
                    }
                    trackSellRequestConversion(data, !!phone ? null : +phonelessConversionPct);
                    trackEvent('Flow', data.requestId, 'sellV3Step3Chat', {
                        hasPhone: !!phone,
                        abTestWHYVersion: window.abTestWHYVersion
                    })
                        .withOptimizely()
                        .withGA();
                    trackEvent('Flow', 'SellRequest', 'sellerRequestStep7RequestCreated', {
                        abTestWHYVersion: window.abTestWHYVersion
                    })
                        .withGA()
                        .withOptimizely();

                    this.props.parent.setState({
                        requestId: data.requestId,
                        currentStep: 'SELL_CHAT'
                    });
                    return data;
                });
            });
        });
    }

    handleDuplicateRequest({address, name, email, requestId}) {
        this.props.parent.setState({
            currentStep: 'LOGIN_LINK',
            loginLinkProps: {
                address,
                name,
                email,
                requestId,
                isBuyer: false
            }
        });
    }

    wantToTalk() {
        trackEvent('Flow', 'SellRequest', 'IWantToTalk').withGA();
    }

    handleValidation(ref, noCheckMark) {
        $(ref)
            .parent()
            .find('.check-mark')
            .remove();
        if ($(ref).valid() || (!$(ref).val() && !$(ref).hasClass('required'))) {
            $(ref)
                .parent()
                .removeClass('error');
            if (!noCheckMark) {
                $(ref).after('<div class="check-mark"><i class="icon-nav-check"/></div>');
            }
            return;
        } else {
            $(ref)
                .parent()
                .addClass('error');
        }
        if (ref == this.refs.email && this.isRealtor) {
            this.validator.showErrors({
                email:
                    'Agents are not allowed to create a request. For more information please visit our <a href="/re/faq-about-upnest" style="color: inherit; text-decoration: underline">FAQ</a>.'
            });
            $(ref)
                .parent()
                .addClass('error');
        } else if (ref == this.refs.name) {
            this.validator.showErrors({
                name: 'Please enter your first and last name.'
            });
        } else if (this.isAdmin) {
            this.validator.showErrors({
                email: 'Can not create new request using UA email.'
            });
            $(ref)
                .parent()
                .addClass('error');
        }
    }

    handleValidateEmailFormat = () => {
        this.handleValidation(this.refs.email);

        $('#suggestedEmail').remove();
        $(this.refs.email).mailcheck({
            suggested: ($element, suggestion) => {
                $element.after(`
                    <span id="suggestedEmail">
                        did you mean
                        <span class="suggestion"> ${suggestion.full.split('@')[0]}@<span class="corrected">${
                    suggestion.full.split('@')[1]
                }</span></span>?
                    </span>
                `);
                $('#suggestedEmail').on('click', () => {
                    $('#suggestedEmail').remove();
                    $element.val(suggestion.full);
                    return this.checkUserExistsDebounced();
                });
            },
            empty: $element => {
                this.checkUserExistsDebounced();
            }
        });
    };

    render() {
        if (this.props.realtorId) {
            return (
                <i
                    className="fa fa-spinner fa-pulse"
                    style="color:#aaa;font-size:70px;margin:200px auto 0;position:relative;text-align:center;width:100%"
                />
            );
        }

        const {
            userExists,
            isLoggedIn,
            loginProvider,
            selectedLoginProvider,
            isPerformingSocialLogin,
            isPhoneVisible,
            errors
        } = this.state;
        const loginProviderName = PROVIDER_NAMES_BY_KEY[loginProvider];

        return (
            <div id="sell-flow-step5" className="flow-step">
                <div id="contact-form-top-text">
                    <img src={this.props.amPhoto} className="img-circle pull-left mobile-buy-sell-flow-ua-img" />
                    <div>
                        You will receive a <b>free home value analysis</b> and{' '}
                        <b>3 - 5 proposals from our top agents.</b>
                    </div>
                </div>
                <div className="flow-step-header-text">
                    <strong>Where should we email your free agent proposals?</strong>
                </div>

                <form ref={elem => (this.refs.form = elem)}>
                    <div
                        ref={elem => (this.refs.addressBlock = elem)}
                        className="float-label-div"
                        style={{position: 'relative'}}>
                        <input
                            className="required validStreetCityState"
                            ref={elem => (this.refs.address = elem)}
                            id="address"
                            name="address"
                            placeholder=""
                            autoComplete="street-address"
                            value={this.props.address}
                            onFocus={() => this.refs.address.setAttribute('autocomplete', 'street-address')}
                            onBlur={() => this.validateAddress()}
                        />
                        <label htmlFor="address" className="float-label required">
                            Property address
                        </label>
                        <i className="contact-form-icon icon-location-outline" />
                        {this.props.parent.state.homeType === 'Condominium' && (
                            <div
                                className="float-label-div"
                                style="position: absolute;top:0;right: 0;width: 80px; margin: 0">
                                <input
                                    maxLength="5"
                                    ref={elem => (this.refs.unit = elem)}
                                    id="unit"
                                    name="unit"
                                    placeholder=""
                                    style="padding-left: 10px; outline: none; padding-right: 8px;"
                                    onBlur={() => $(this.refs.unit).valid() || this.notifyOnValidationErrorThrottled()}
                                />
                                <label htmlFor="unit" className="float-label" style="left: 10px">
                                    Unit #
                                </label>
                            </div>
                        )}
                    </div>
                    <div className="float-label-div" style={{position: 'relative'}}>
                        <input
                            ref={elem => (this.refs.name = elem)}
                            id="name"
                            name="name"
                            className="required"
                            minwords="2"
                            minLength="5"
                            maxLength="100"
                            autoComplete="name"
                            onBlur={() => this.handleValidation(this.refs.name)}
                        />
                        <label htmlFor="name" className="float-label required">
                            First and last name
                        </label>
                        <i className="contact-form-icon icon-profile-outline" />
                        {!!errors.name && (
                            <label htmlFor="name" generated="true" className="error">
                                {errors.name}
                            </label>
                        )}
                    </div>
                    <div className="float-label-div" style={{position: 'relative'}}>
                        <input
                            ref={elem => (this.refs.email = elem)}
                            id="email"
                            className="email required"
                            type="email"
                            name="email"
                            autoComplete="email"
                            autoCorrect="off"
                            autoCapitalize="off"
                            disabled={!!loginProvider && !!isLoggedIn}
                            onBlur={this.handleValidateEmailFormat}
                            onInput={this.onEmailInput.bind(this)}
                            onKeyDown={this.onEmailKeyDown.bind(this)}
                        />
                        <label htmlFor="email" className="float-label required">
                            Email
                        </label>
                        {userExists && (
                            <span id="welcomeBack" className="secondary-label required" data-hb-ref="welcomeBackLabel">
                                Welcome Back!
                            </span>
                        )}
                        <i className="contact-form-icon icon-contact-email-outline" />
                        {!!errors.email && (
                            <label htmlFor="email" generated="true" className="error">
                                {errors.email}
                            </label>
                        )}
                    </div>
                    <div className={'float-label-div ' + (isPhoneVisible ? '' : ' hidden')}>
                        <input
                            ref={elem => (this.refs.phone = elem)}
                            id="phone"
                            className="phoneUS required"
                            maxLength={this.props.isNotUS ? '11' : '14'}
                            type="tel"
                            name="phone"
                            autoComplete="tel"
                            onBlur={() => {
                                this.handleValidation(this.refs.phone, !$(this.refs.phone).val());
                            }}
                            onKeyPress={event => this.onPhoneChange(event, this.props.country)}
                        />
                        <label htmlFor="phone" className="float-label">
                            Phone for account verification (required)
                        </label>
                        <i className="contact-form-icon icon-contact-phone-outline" />
                        {!!errors.phone && (
                            <label htmlFor="phone" generated="true" className="error">
                                {errors.phone}
                            </label>
                        )}
                    </div>

                    {window.SELL_SOCIAL_LOGIN_ENABLED && (
                        <div
                            className={
                                'social-login-chooser social-login-chooser-buy-sell-flow ' +
                                (loginProvider || isLoggedIn || isPerformingSocialLogin ? ' hidden' : '')
                            }>
                            <div className="hidden-xs status-normal social-text">Or sign up with social media</div>
                            <div className="visible-xs status-normal social-text">Or log in with</div>
                            <div className="social-login-buttons social-login-buttons-buy-sell-flow">
                                <button
                                    type="button"
                                    className="social-button social-button-google social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('google')}>
                                    <img src={global.imageBaseUrl + 'oneall/google-icon.svg'} alt="Google logo" />
                                    <img
                                        className="google-text"
                                        src={global.imageBaseUrl + 'oneall/google-text.svg'}
                                        alt="Log in with Google"
                                    />
                                </button>
                                <button
                                    type="button"
                                    className="social-button social-button-facebook social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('facebook')}>
                                    <img src={global.imageBaseUrl + 'oneall/facebook-icon.svg'} alt="Facebook logo" />
                                    <img
                                        className="facebook-text"
                                        src={global.imageBaseUrl + 'oneall/facebook-text.svg'}
                                        alt="Log in with Facebook"
                                    />
                                </button>
                                <button
                                    type="button"
                                    className="social-button social-button-linkedin social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('linkedin')}>
                                    <img src={global.imageBaseUrl + 'oneall/linkedin-icon.svg'} alt="Linkedin logo" />
                                    <img
                                        className="linkedin-text"
                                        src={global.imageBaseUrl + 'oneall/linkedin-text.svg'}
                                        alt="Log in with Facebook"
                                    />
                                </button>
                            </div>
                        </div>
                    )}
                    {isPerformingSocialLogin && (
                        <div className="social-login-progress">
                            <div className="status-normal social-text">
                                Logging in with {PROVIDER_NAMES_BY_KEY[loginProvider || selectedLoginProvider]}...
                            </div>
                            <img className="spinner" src={global.imageBaseUrl + '/spinner.gif'} />
                        </div>
                    )}

                    {/* <div className="checkboxes-block">
                    <div className="secure-block">
                        <img src={global.imageBaseUrl + '/buysell/svg/secure.svg'} style="float: left"/>
                        <div>Your data is never shared without your consent.</div>
                    </div>
                    <div className="pretty p-svg p-plain">
                        <input ref={elem => this.refs.talkNow = elem} type="checkbox" checked="checked" name="talkNow"
                            onClick={() => this.wantToTalk()}/>
                        <div className="state p-default">
                            <svg className="svg svg-icon" viewBox="0 0 20 20" style={{'background-color': '#80878e'}}>
                                <path
                                    d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                    style="stroke: white;fill:white;"></path>
                            </svg>
                            <label>I want agents to contact me as soon as possible.</label>
                        </div>
                    </div>
                </div> */}
                </form>

                {(!window.SELL_SOCIAL_LOGIN_ENABLED || !loginProvider) && (
                    <button type="button" className="continue-button" onClick={this.submit.bind(this)}>
                        Continue
                    </button>
                )}
                {window.SELL_SOCIAL_LOGIN_ENABLED && !!loginProvider && (
                    <button
                        type="button"
                        id={`continue-${loginProvider}-button`}
                        className="continue-button"
                        onClick={isLoggedIn ? this.submit.bind(this) : this.doSocialLogin.bind(this, loginProvider)}>
                        Continue with {loginProviderName}
                    </button>
                )}

                <div className="consent">
                    By clicking "Continue", I consent to UpNest’s{' '}
                    <a href="https://www.upnest.com/re/terms" target="_blank">
                        Terms of Service
                    </a>{' '}
                    and{' '}
                    <a href="https://www.realtor.com/privacy-policy/" target="_blank">
                        Privacy Policy
                    </a>
                    , and I consent to have UpNest or one of its partners contact me via auto-dialed phone calls, text
                    messages, and prerecorded messages, on the phone number I provided even if I'm on any Do-Not-Call
                    list and even if I am charged for the call or text. I understand that my consenting is not a
                    condition of my receiving UpNest services and that I can call{' '}
                    <span style="white-space: nowrap">1-800-692-5010</span> for services if I do not consent.
                </div>

                <div className="flow-spacer" />
            </div>
        );
    }
}

